import type { IProcessActivityReadSection } from '@common/interfaces/processActivityReadSection';
import type { HolterDirectExaminationRequestData } from '@common/validation/customControls/cardiology/holter/holterDirectExaminationRequestSchemas';
import type { OsaReferralReadData } from '@common/validation/customControls/osas/osasReferralSchemas/osasReferralReadSchema';
import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';
import { ProcessActivityAllergiesRead } from '@frontend/components/pages/episodeCategory/customControls/processActivityProfessionalSummaryData/components/processActivityAllergies/ProcessActivityAllergiesRead';
import { ProcessActivityEpisodesAndJournalsRead } from '@frontend/components/pages/episodeCategory/customControls/processActivityProfessionalSummaryData/components/processActivityEpisodesAndJournals/ProcessActivityEpisodesAndJournalsRead';
import { ProcessActivityLabResultsRead } from '@frontend/components/pages/episodeCategory/customControls/processActivityProfessionalSummaryData/components/ProcessActivityLabReasultsRead';

type data = OsaReferralReadData | HolterDirectExaminationRequestData;

export function setProfessionalSummaryReadComponents({
    map,
    readSections,
    processActivityId,
}: {
    map: ComponentsMap;
    processActivityId: string;
    readSections: IProcessActivityReadSection[];
}) {
    const allergiesItem = getProcessActivityReadSectionItem<data>()(readSections, 'allergies');

    if (allergiesItem?.value?.length) {
        map.set(
            'allergies',
            <ProcessActivityAllergiesRead
                processActivityId={processActivityId}
                showParent={() => {}}
            />
        );
    }

    const episodesAndJournalsItem = getProcessActivityReadSectionItem<data>()(readSections, 'episodesAndJournals');

    if (episodesAndJournalsItem?.value?.episodes?.length) {
        map.set(
            'episodesAndJournals',
            <ProcessActivityEpisodesAndJournalsRead
                processActivityId={processActivityId}
                showParent={() => {}}
            />
        );
    }

    const labResultItem = getProcessActivityReadSectionItem<data>()(readSections, 'labResults');

    if (labResultItem?.value?.length) {
        map.set(
            'labResults',
            <ProcessActivityLabResultsRead
                processActivityId={processActivityId}
                showParent={() => {}}
            />
        );
    }
}
